import React from 'react'
import BreadcrumbArea from '../../ShearOne/BreadcrumbArea';
import MedtrustHeader from '../../Compoents/MedtrustHeader';
import MedtrustFooter from '../../Compoents/MedtrustFooter';
import { useLocation } from 'react-router-dom';

const RoyaleeHospital = () => {
    const { state } = useLocation();
  const hospital = state?.hospital;

  if (!hospital) {
    return <div>No hospital data found.</div>;
  }
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Hospital Details', active: true }
    ];

    return (
        <>
            <div className="min-h-screen bg-[#f5f7fa]">
                <MedtrustHeader />
                <BreadcrumbArea
                    title="Hospital Details"
                    backgroundImage="assets/imgs/appointment/appointment.png"
                    links={breadcrumbLinks}
                />




                <section class="portfolio-details section-space">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="portfolio-details__media-wrapper position-relative mb-40">
                                    <div class="portfolio-details__media">
                                        <img
                                            src={hospital.image}
                                            alt="Hospital facility"
                                            className="w-full object-contain transition-transform"
                                        />
                                        
                                    </div>

                                    <div class="portfolio-details__author">
                                        <div class="portfolio-details__author-item">
                                            <span>Hospital Name</span>
                                            <h5>{hospital.name}</h5>
                                        </div>
                                        <div class="portfolio-details__author-item">
                                            <span>City</span>
                                            <h5>{hospital.city}</h5>
                                        </div>
                                        {/* <div class="portfolio-details__author-item">
                                            <span>Doctor Name</span>
                                            <h5>Dr. David smith</h5>
                                        </div> */}
                                    </div>
                                </div>
                                <div class="portfolio-details__content mb-60">
                                    <div class="row align-items-center">
                                        <div class="col-lg-9">
                                            <div class="portfolio-details__content-text">
                                                <h3 class="mb-10 title-animation">Vibrance Voyage Navigating Toward Optimal </h3>
                                                <p class="mb-20">Web designing in a powerful way of just not an only professions, however, in a passion
                                                    for our Company. We have to a tendency to believe the idea that smart looking of any websitet
                                                    in on visitors.Web designing in a powerful way of just not an only profession Web designing in a powerful way of just not
                                                    an Web designing in a powerful way of just not an only professions, however, in a passion for our Company. We have to a tendency to believe the idea that smart
                                                    looking of any websitet in on visitors.Web designing in a powerful way of just not an only profession Web designing in a powerful way of just not an only
                                                </p>
                                                <p class="mb-0">Web designing in a powerful way of just not an only professions, however,
                                                    in a passion for our Company. We have to a tendency to believe the idea that smart looking of any websitet in on visitors.Web designing in a powerful way of just not an only profession Web designing in a powerful way
                                                    of just not an Web designing in a powerful way of just not a
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="portfolio-details__content__contact text-center">
                                                <h4 class="mb-25 title-animation">Are You ready to contact with us</h4>
                                                <h6 class="mb-20"><a href="tel:888123456765"><i class="fa-solid fa-phone"></i>(+888) 123 456 765</a></h6>

                                                <a href="appoinment.html" class="rr-btn">
                                                    <span class="btn-wrap">
                                                        <span class="text-one">Register Now <i class="fa-solid fa-plus"></i></span>
                                                        <span class="text-two">Register Now <i class="fa-solid fa-plus"></i></span>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="portfolio-details__media-wrapper mb-30">
                                    <div class="row">
                                        <div class="col-lg-3 col-sm-6">
                                            <div class="portfolio-details__media-wrapper__item mb-md-30 mb-sm-30 mb-xs-30">
                                                <img src="assets/imgs/about-us-3/about-us-3.png" class="img-fluid" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-sm-6">
                                            <div class="portfolio-details__media-wrapper__item mb-md-30 mb-sm-30 mb-xs-30">
                                                <img src="assets/imgs/about-us-3/about-us-3.png" class="img-fluid" alt="" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="portfolio-details__media-wrapper__item">
                                                <img src="assets/imgs/blog/blog-item-1.jpg" class="img-fluid" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="portfolio-details__content">
                                    <div class="portfolio-details__content-text">
                                        <h3 class="mb-20 title-animation">Holistic Haven Where Health Blossoms Every Day</h3>
                                        <p class="mb-0">Web designing in a powerful way of just not an only professions, however, in a passion for our Company. We have to a tendency to believe the idea that smart looking of any websitet in on visitors.Web designing in a powerful way of just not an only profession Web designing in a powerful way of just not an Web designing in a powerful way of just not an only professions, however, in a passion for our Company. We have to a tendency to believe the idea that smart looking of any websitet in on visitors.Web designing in a powerful way of just not an only profession Web designing in a powerful way of just not an only medical duty operation complete</p>
                                    </div>
                                    <ul class="portfolio-details__content__list mt-20">
                                        <li><span><i class="fa-solid fa-check"></i></span><h5>Lorem Ipsum passage, and going through</h5></li>
                                        <li><span><i class="fa-solid fa-check"></i></span><h5>Healthcare Excellence, Compassionate Healing</h5></li>
                                        <li><span><i class="fa-solid fa-check"></i></span><h5>Many desktop publishing packages and web page</h5></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <MedtrustFooter />
            </div>
        </>
    );
}


export default RoyaleeHospital;
